import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { styled } from "@mui/material";
import WealthAPILogo from "@components/Logo/images/wealthapi-logo.svg?url";
import WealthAPIWhiteLogo from "@components/Logo/images/wealthapi-logo-white.svg?url";

const Container = styled("div")`
  display: flex;
  min-width: 249px;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(5)};
  ${({ theme }) => theme.breakpoints.down(800)} {
    width: 200px;
    gap: ${({ theme }) => theme.spacing(3)};
  }
  ${({ theme }) => theme.breakpoints.down(720)} {
    justify-content: center;
  }
`;

export const PoweredBy = () => {
  const theme = useTheme();
  const isLess720 = useMediaQuery(theme.breakpoints.down(720));

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems={isLess720 ? "center" : "flex-start"}
    >
      <Container>
        <Typography variant="body3" noWrap>
          Powered by:
        </Typography>
        <img
          src={
            theme.palette.mode === "dark" ? WealthAPIWhiteLogo : WealthAPILogo
          }
          width={isLess720 ? "61px" : "92px"}
          height={isLess720 ? "30px" : "45px"}
          alt="wealthAPI GmbH"
        />
      </Container>
    </Box>
  );
};
